import { PasseriniAPI } from './apiService';
import { extractFilename } from '../utils/path';

interface UploadParams {
  name: string;
  file: File;
}

interface DownloadParams {
  path: string;
}

interface UploadResponse {
  path: string;
}

export const storageUpload = async ({ name, file }: UploadParams): Promise<string> => {
  const formData = new FormData();
  formData.append('name', name);
  formData.append('file', file);

  const response = await PasseriniAPI.post('/upload', formData);
  const { path } = response.data as unknown as UploadResponse;
  return path;
};

export const storageDownload = async ({ path }: DownloadParams): Promise<void> => {
  const filename = extractFilename(path);
  const pathEncode = window.btoa(path);

  const response = await PasseriniAPI.get(`/download/${pathEncode}`, {
    responseType: 'blob'
  });

  const blob = new Blob([response.data], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const element = document.createElement('a');
  element.setAttribute('href', url);
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
